'use client';

import type { HandleChangeAnswerType } from '../model';
import type { AnswerUserType } from '~/model/AnswerUserType';
import type { ChoiceType } from '~/model/ChoiceType';
import { useTranslations } from 'next-intl';
import { useLayoutEffect } from 'react';
import { useFocus } from '~/hooks/useFocus';

export const SelectTypeQuestion = ({
  answerUser,
  answerChoices,
  questionId,
  handleChangeAnswer,
  type,
  langValue,
  disabled = false,
}: {
  answerUser: AnswerUserType;
  answerChoices: ChoiceType[];
  questionId: string;
  handleChangeAnswer: HandleChangeAnswerType;
  type: string;
  langValue: string;
  disabled?: boolean;
}) => {
  const t = useTranslations('FORM');
  const [selectRef, setInputFocus] = useFocus();

  useLayoutEffect(() => {
    setInputFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRef.current]);

  return (
    <div className="select-question vtmn-select_container">
      <select
        ref={selectRef}
        data-testid="select"
        data-cy="select"
        value={
          answerUser?.[questionId] != null
          && (answerUser[questionId].answer_choices as string[])
        }
        required
        onChange={e => handleChangeAnswer(e.target.value, questionId, type)}
        disabled={disabled}
      >
        <option value="">{t('SELECT_OPTION')}</option>
        {answerChoices?.length > 0
          && answerChoices.map((choice) => {
            return (
              <option
                lang={langValue}
                data-testid="option"
                key={`${questionId}-${choice.id}`}
                value={choice['@id']}
              >
                {choice.title}
              </option>
            );
          })}
      </select>
    </div>
  );
};
